import { render } from "./GotoLesson.vue?vue&type=template&id=7e12efab&scoped=true"
import script from "./GotoLesson.vue?vue&type=script&lang=js"
export * from "./GotoLesson.vue?vue&type=script&lang=js"

import "./GotoLesson.vue?vue&type=style&index=0&id=7e12efab&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e12efab"]])

export default __exports__